<!-- eslint-disable max-len -->
<template>
  <div :class="$options.name">
    <v-card>
      <v-card-title class="mb-5">Настройки слоя</v-card-title>

      <v-card-text class="pb-0">
        <custom-select
          :data="settings.source"
          :list="sourceList"
          label="Тип источника данных"
          source
          hide-details
          @change="onSourceChange"
        />
      </v-card-text>

      <url-settings v-if="isUrl" :settings="settings" />
      <wfs-settings
        v-if="isWfs"
        :settings="settings"
        :layer-attributes="layerAttributes"
        @set-layer-attributes="setLayerAttributes"
        @srs-change="setSrs"
      />

      <mapping-attributes :settings="settings" />

      <view-settings :settings="settings" :type-list="typeList" :icon="icon" />

      <div class="mt-2 d-flex pa-5">
        <div class="d-flex flex-grow-1" />
        <v-btn color="primary" @click="onSave">Сохранить</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable max-len */
import { mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import getTextColor from '@/utils/get-text-color';
import http from '@/utils/api';
import CustomSelect from '@/components/ui/custom-select';
import MappingAttributes from '@/components/page/layers/settings/MappingAttributes.vue';
import ViewSettings from '@/components/page/layers/settings/ViewSettings.vue';
import UrlSettings from '@/components/page/layers/settings/UrlSettings.vue';
import WfsSettings from '@/components/page/layers/settings/WfsSettings.vue';
import { isObject } from '@/utils/object';
import * as defaultStyles from '@/utils/styles';
import * as types from '@/constants/layer-types';

export default {
  name: 'external-url-tab',

  components: {
    CustomSelect,
    MappingAttributes,
    UrlSettings,
    ViewSettings,
    WfsSettings,
  },

  model: {
    prop: 'settingsProp',
    event: 'update',
  },

  props: {
    settingsProp: {
      type: Object,
      default: () => {},
    },

    icon: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      iconWidth: null,
      isLoadingGeoserverInfo: false,
      layerAttributes: [],
      searchQuery: '',
      settings: {
        hasSymbolText: false,
        mappings: [],
        source: types.WFS,
        sourceSettings: defaultStyles.wfsSettings(),
        style: defaultStyles.pointStyle(),
        symbol: defaultStyles.symbolStyle(),
        referenceProperties: [],
        referencePanelTitle: [],
        timelineType: false,
        type: types.POINT,
      },
      sourceList: types.HTTP_SOURCE_LIST,
      typeList: types.LAYER_TYPE_LIST,
    };
  },

  computed: {
    isUrl() {
      return this.settings.source === types.URL;
    },

    isWfs() {
      return this.settings.source === types.WFS;
    },

    filteredLayers() {
      return (this.layers || [])
        .flatMap((l) => {
          if (l.value === this.settings.layer) return l;

          return l.text.toLowerCase().includes(this.searchQuery.toLowerCase()) ? l : [];
        });
    },

  },


  async created() {
    this.initSettings();
    this.debouncedLayerSearch = debounce(this.onLayerSearch, 300);
    if (this.settings.geoserverUrl) {
      await this.getGeoserverInfo();
    }
    this.valuesWithoutChange = Object.assign({}, this.settings);
    this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
  },

  methods: {
    ...mapActions(['showNotify']),
    beforeLeave() {
      return this.settings;
    },
    onSave() {
      this.valuesWithoutChange = Object.assign({}, this.settings);
      this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
      this.$emit('save', this.settings);
    },

    initSettings() {
      Object.entries(this.settingsProp).forEach(([key, value]) => {
        if (key in this.settings) {
          this.settings[key] = value;
        }
      });
    },

    async getGeoserverInfo() {
      this.isLoadingGeoserverInfo = true;
      try {
        const layersRawList = await http.get(
          'admin/wms/info',
          {
            params: {
              geoserver: this.settings.geoserverUrl,
            },
          },
        );

        let layersList = [];
        if (isObject(layersRawList)) {
        // https://vuetifyjs.com/en/api/v-select/#props
          Object.keys(layersRawList).forEach((k) => {
            if (typeof layersRawList[k] !== 'string') {
              return;
            }
            layersList.push({
              text: layersRawList[k],
              value: k,
            });
          });
        } else {
          layersList = layersRawList;
        }

        this.layers = layersList;
      } catch (e) {
        console.error(e.message);
        this.showNotify({
          type: 'error',
          message: 'Ошибка при получении списка слоёв',
        });
        this.layers = [];
      } finally {
        this.isLoadingGeoserverInfo = false;
      }
    },

    onLayerSearch(query) {
      this.searchQuery = query;
    },

    setLayerAttributes(attributes) {
      this.layerAttributes = attributes;
    },

    getTextColor,

    onSourceChange(source) {
      if (this.settings.source !== source) {
        this.settings.source = source;

        switch (source) {
          case types.WFS:
            this.settings.sourceSettings = defaultStyles.wfsSettings();
            break;
          case types.URL:
          default:
            this.settings.sourceSettings = defaultStyles.urlSettings();
        }
      }
    },

    setSrs(srs) {
      this.settings.sourceSettings.srs = srs;
    },
  },
};

</script>
